import "./ArchiveProductTemplate.module.css"
import Intestazione from "@/reusable_sections/Header"
import PageTitleAndNavigationSection from "./sections/PageTitleAndNavigationSection"
import ProductGridAndPaginationSection from "./sections/ProductGridAndPaginationSection"
import PieDiPagina from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <Intestazione />
      <PageTitleAndNavigationSection />
      <ProductGridAndPaginationSection />
      <PieDiPagina />
    </div>
  )
}
